import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { ColorType, IconName, IconWeight } from '../../models';
import { GsIconComponent } from '../gs-icon/gs-icon.component';

@Component({
  selector: 'gs-info-box',
  imports: [GsIconComponent],
  templateUrl: './gs-info-box.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      :host {
        display: flex;
        width: 100%;
        justify-content: center;
      }
    `
  ]
})
export class GsInfoBoxComponent {
  // Inputs & Models
  /** The title of the alert wich has to be set for diplay */
  readonly title = input.required<string>();
  /** Optional text shown underneath the title */
  readonly description = input<string>();
  readonly iconName = input<IconName>('warning');
  readonly iconWeight = input<IconWeight>('light');
  readonly color = input<ColorType>('warning');

  // Getters
  get colorsClasses(): string {
    return ` bg-${this.color()}-main text-${this.color()}-contrast `;
  }
}
